import { APICallV2Post, APICallV4Post } from 'reactApp/api/APICall';
import { apiMigrateFolderV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';

const method = 'folder/add';

class AddFolderAPIV2Call extends APICallV2Post {
    _method = method;
}

class AddFolderAPIV4Call extends APICallV4Post {
    _method = method;
}

export const addFolderApiCall = (home: string, conflict = 'ignore') => {
    const apiInstance = apiMigrateFolderV2ToV4.add ? new AddFolderAPIV4Call() : new AddFolderAPIV2Call();

    return apiMigrateFolderV2ToV4.add
        ? apiInstance
              .makeRequest({ home, conflict })
              .then((response) => response?.data?.body)
              .catch((error) => {
                  throw [error.response?.error, error.status, error, error.responseText];
              })
        : apiInstance
              .makeRequest({ home, conflict })
              .then((response) => response?.data?.body)
              .catch((error) => {
                  throw error?.response?.body;
              });
};
